import { MaterialDesignContent } from "notistack";
// @mui
import { alpha, styled } from "@mui/material/styles";

// ----------------------------------------------------------------------

export const StyledNotistack = styled(MaterialDesignContent)(({ theme }) => {
    const isLight = theme.palette.mode === "light";

    return {
        "& #notistack-snackbar": {
            maxWidth: 500,
            minHeight: 20,
            ...theme.typography.body1,
            padding: 0,
            alignItems: "start",
            flexGrow: 1,
            wordWrap: "break-word", /* Break long words to wrap */
            overflowWrap: "anywhere", /* Modern equivalent of word-wrap */
            whiteSpace: "normal"
        },
        "&.notistack-MuiContent": {
            padding: "14px 10px",
            paddingRight: "14px",
            color: theme.palette.text.primary,
            boxShadow: "none",
            // boxShadow: theme.customShadows.z8,
            borderRadius: "14px",
            backgroundColor: theme.palette.background.paper,
            zIndex: 9
        },

        "&.notistack-MuiContent-default": {
            padding: theme.spacing(1),
            color: isLight ? theme.palette.common.white : theme.palette.grey[800],
            backgroundColor: isLight ? theme.palette.grey[800] : theme.palette.common.white
        },

        "&.notistack-MuiContent-info": {
            "&::after": {
                content: "\"\"",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "100%",
                backgroundColor: alpha(theme.palette.info.main, 0.2),
                borderRadius: "14px",
                overflow: "hidden"
            }
        },

        "&.notistack-MuiContent-success": {
            "&::after": {
                content: "\"\"",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "100%",
                backgroundColor: alpha(theme.palette.success.main, 0.2),
                borderRadius: "14px",
                overflow: "hidden"
            }
        },

        "&.notistack-MuiContent-warning": {
            "&::after": {
                content: "\"\"",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "100%",
                backgroundColor: alpha(theme.palette.warning.main, 0.2),
                borderRadius: "14px",
                overflow: "hidden"
            }
        },

        "&.notistack-MuiContent-error": {
            "&::after": {
                content: "\"\"",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "100%",
                backgroundColor: alpha(theme.palette.error.main, 0.2),
                borderRadius: "14px",
                overflow: "hidden"
            },
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "flex-start"
        },

        "&.notistack-MuiContent-successUpdate": {
            padding: "14px 18px 14px 10px",
            borderRadius: "14px",
            minWidth: "330px",
            backgroundColor: theme.palette.background.success,
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "flex-start"
        },

        "&.notistack-MuiContent-failUpdate": {
            padding: "14px 18px 14px 10px",
            borderRadius: "14px",
            minWidth: "330px",
            backgroundColor: theme.palette.background.fail
        }
    };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled("span")(({ color, theme }) => ( {
    position: "relative",
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginRight: "11px",
    color: theme.palette[color].main
} ));
